import { render, staticRenderFns } from "./Blackjack.vue?vue&type=template&id=20254b6c&scoped=true"
import script from "./Blackjack.vue?vue&type=script&lang=js"
export * from "./Blackjack.vue?vue&type=script&lang=js"
import style0 from "./Blackjack.vue?vue&type=style&index=0&id=20254b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20254b6c",
  null
  
)

export default component.exports